export default __webpack_public_path__ + "static/media/h27koritu.46eaa38f.mp3";